(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["knotz-editorial-focus"] && !Shopify.designMode) return;
  try {
    
 if (!customElements.get('knotz-editorial-focus')) {
  customElements.define('knotz-editorial-focus', class extends HTMLElement {
   connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.addEventListener('click', event => {
     const tab = event.target.closest('[role="tab"]');
     if (tab) this.select(tab);
    });
    this.addEventListener('keydown', event => {
     const tab = event.target.closest('[role="tab"]');
     if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
     event.preventDefault();
     let index = this.tabs.indexOf(tab);
     if (event.key === 'Home') index = 0;
     else if (event.key === 'End') index = this.tabs.length - 1;
     else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
     this.select(this.tabs[index]); this.tabs[index].focus();
    });
   }
   select(tab) {
    const id = tab.getAttribute('aria-controls');
    this.tabs.forEach(item => {const selected = item === tab;item.setAttribute('aria-selected',String(selected));item.tabIndex = selected ? 0 : -1;});
    this.panels.forEach(panel => panel.hidden = panel.id !== id);
   }
  });
 }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knotz-flash-popup"]) return;
  try {
    
function initKnotzFlashPopups(scope = document) {
  scope.querySelectorAll('[data-knotz-flash-popup]').forEach(popup => {
    if (popup.dataset.initialized || typeof popup.showModal !== 'function') return;
    popup.dataset.initialized = 'true';
    const preview = Boolean(window.Shopify && window.Shopify.designMode);
    const storageKey = 'knotz-flash-10-popup-v1';
    let seen = false;
    try { seen = sessionStorage.getItem(storageKey) === 'shown'; } catch (error) {}
    let priorOverflow;
    let locked = false;
    const restoreScroll = () => {
      if (!locked) return;
      document.documentElement.style.overflow = priorOverflow;
      locked = false;
    };
    popup.querySelectorAll('[data-flash-close]').forEach(button => button.addEventListener('click', () => popup.close()));
    popup.addEventListener('close', restoreScroll);
    popup.addEventListener('click', event => {
      if (event.target !== popup) return;
      const box = popup.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) popup.close();
    });
    if (seen && !preview) return;
    const delay = preview ? 900 : Number(popup.dataset.delay || 4000);
    setTimeout(() => {
      if (!popup.isConnected || popup.open || document.visibilityState === 'hidden') return;
      if (document.querySelector('dialog[open], cart-drawer[open], header-sidebar[open]')) return;
      popup.showModal();
      priorOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      locked = true;
      try { sessionStorage.setItem(storageKey, 'shown'); } catch (error) {}
    }, delay);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(popup)) {
        if (popup.open) popup.close();
        restoreScroll();
      }
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initKnotzFlashPopups());
else initKnotzFlashPopups();
document.addEventListener('shopify:section:load', event => initKnotzFlashPopups(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knotz-letter-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('knotz-letter-order')) {
    class KnotzLetterOrder extends HTMLElement {
      static parseName(value) {
        const name = String(value || '').trim().replace(/ +/g, ' ');
        const validCharacters = /^[A-Za-z]+(?: +[A-Za-z]+)*$/.test(name);
        const letters = (name.match(/[A-Za-z]/g) || []).map(letter => letter.toUpperCase());
        return { name, letters, count: letters.length, validCharacters };
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-kl-config]').textContent);
        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('[data-variant-id]');
        this.price = this.querySelector('[data-price]');
        this.priceNote = this.querySelector('[data-price-note]');
        this.summary = this.querySelector('[data-summary]');
        this.submitButton = this.querySelector('[data-submit]');
        this.error = this.querySelector('[data-error]');
        this.nameInput = this.querySelector('[data-name]');
        this.letterSelect = this.querySelector('[data-letter]');
        this.spelling = this.querySelector('[data-spelling]');
        this.money = new Intl.NumberFormat('en-PK', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        const initial = this.config.variants.find(variant => String(variant.id) === String(this.config.selectedVariant));
        if (initial && this.letterSelect) {
          this.letterSelect.value = initial.options[1];
          const size = this.querySelectorAll('[data-size]');
          size.forEach(input => { input.checked = input.value === initial.options[0]; });
        }
        this.form.addEventListener('input', event => {
          if (event.target === this.nameInput && this.spelling) this.spelling.checked = false;
          this.update(false);
        });
        this.form.addEventListener('change', () => this.update(false));
        this.form.addEventListener('submit', event => {
          this.update(true);
          if (!this.selectedVariant || !this.form.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
        this.addEventListener('cart:error', event => {
          this.error.textContent = String(event.detail.error || this.config.labels.unavailable);
          this.error.hidden = false;
        });
        this.querySelectorAll('[data-image-url]').forEach(button => {
          button.addEventListener('click', () => {
            const image = this.querySelector('.kl-main-image');
            image.src = button.dataset.imageUrl;
            image.removeAttribute('srcset');
            image.alt = button.dataset.imageAlt || '';
            this.querySelectorAll('[data-image-url]').forEach(thumbnail => thumbnail.setAttribute('aria-pressed', String(thumbnail === button)));
          });
        });
        this.update(false);
      }

      formatMoney(cents) {
        if (this.config.currency === 'PKR') return 'Rs ' + this.money.format(cents / 100);
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.config.currency }).format(cents / 100);
      }

      interpolate(template, values) {
        return template.replace(/\{([a-zA-Z]+)\}/g, (match, key) => values[key] === undefined ? match : String(values[key]));
      }

      update(showError) {
        const labels = this.config.labels;
        const isName = this.config.mode === 'name';
        let variant;
        let message = '';
        let values = {};
        if (isName) {
          const parsed = KnotzLetterOrder.parseName(this.nameInput.value);
          const countInput = this.querySelector('[data-count-property]');
          const countLabel = this.querySelector('[data-count]');
          countInput.value = parsed.count || '';
          countLabel.textContent = parsed.count ? parsed.count + ' ' + labels.letters : labels.noName;
          if (parsed.name && !parsed.validCharacters) message = labels.invalidName;
          else if (parsed.count && parsed.count < 2) message = labels.shortName;
          else if (parsed.count > 12) message = labels.longName;
          if (parsed.validCharacters && parsed.count >= 2 && parsed.count <= 12) {
            variant = this.config.variants.find(item => parseInt(item.options[0], 10) === parsed.count);
          }
          this.nameInput.setCustomValidity(message);
          this.renderName(parsed);
          values = { name: parsed.name, count: parsed.count, colour: labels.ivory, size: '8 inch' };
          if (variant) {
            this.priceNote.textContent = this.interpolate(labels.nameUnit, { count: parsed.count, unit: this.formatMoney(variant.price / parsed.count) });
          }
        } else {
          const size = this.querySelector('[data-size]:checked')?.value;
          const letter = this.letterSelect.value;
          this.querySelector('[data-letter-property]').value = letter;
          this.querySelector('[data-size-hint]').textContent = size?.startsWith('8') ? labels.miniHint : labels.largeHint;
          variant = this.config.variants.find(item => item.options[0] === size && item.options[1] === letter);
          values = { letter, size, colour: labels.ivory };
          this.priceNote.textContent = labels.singleUnit;
        }
        if (variant && !variant.available) message = labels.unavailable;
        this.selectedVariant = variant && variant.available ? variant : null;
        this.variantInput.value = this.selectedVariant ? String(this.selectedVariant.id) : '';
        this.querySelector('[data-size-property]').value = this.selectedVariant ? this.selectedVariant.options[isName ? 1 : 0] : '';
        if (this.selectedVariant) {
          this.price.textContent = this.formatMoney(this.selectedVariant.price);
          this.summary.textContent = this.interpolate(isName ? labels.nameSummary : labels.singleSummary, values);
          this.submitButton.textContent = (isName ? labels.addName : labels.addSingle) + ' — ' + this.formatMoney(this.selectedVariant.price);
        } else {
          this.summary.textContent = isName ? labels.nameEmpty : labels.singleEmpty;
          this.submitButton.textContent = isName ? labels.enterName : labels.chooseLetter;
          if (isName) {
            this.price.textContent = labels.enterName;
            this.priceNote.textContent = this.interpolate(labels.nameUnit, { count: '2–12', unit: this.formatMoney(this.config.variants[0].price / parseInt(this.config.variants[0].options[0], 10)) });
          } else {
            const size = this.querySelector('[data-size]:checked')?.value;
            const candidate = this.config.variants.find(item => item.options[0] === size);
            if (candidate) this.price.textContent = this.formatMoney(candidate.price);
          }
        }
        this.submitButton.disabled = !this.selectedVariant;
        this.error.textContent = message;
        this.error.hidden = !message || !(showError || (this.nameInput && this.nameInput.value.length));
      }

      renderName(parsed) {
        const target = this.querySelector('[data-name-preview]');
        target.replaceChildren();
        target.removeAttribute('aria-label');
        if (!parsed.name || !parsed.validCharacters || parsed.count > 12) {
          const hint = document.createElement('span');
          hint.className = 'kl-hint';
          hint.textContent = this.config.labels.previewHint;
          target.append(hint);
          return;
        }
        Array.from(parsed.name.toUpperCase()).forEach(letter => {
          const tile = document.createElement('span');
          tile.className = letter === ' ' ? 'kl-preview-space' : 'kl-preview-letter';
          tile.setAttribute('aria-hidden', 'true');
          tile.textContent = letter === ' ' ? '' : letter;
          target.append(tile);
        });
        target.setAttribute('aria-label', parsed.name);
      }
    }
    customElements.define('knotz-letter-order', KnotzLetterOrder);
  }

  } catch(e) { console.error(e); }
})();
})();
